export type SyncKey =
  | 'products'
  | 'categories'
  | 'branchInventory'
  | 'salesHistory'
  | 'refunds'
  | 'branches';

export const SYNC_KEYS: SyncKey[] = [
  'products',
  'categories',
  'branchInventory',
  'salesHistory',
  'refunds',
  'branches',
];
